import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://localhost:7050';

export const getRequest = async (url, params = {}) => {
  try {
    const response = await axios.get(`${BASE_URL}${url}`, { params }); // Added params support
    if (response.data.status) {
      return response.data;
    } else {
      throw new Error('Failed to fetch');
    }
  } catch (error) {
    console.error('Error fetching:', error);
    const errorMessage = error.response?.data?.message || "An error occurred while fetching data.";
    return { status: false, error: errorMessage  };
  }
};


export const postRequest = async (url, data) => {
  try {
    const response = await axios.post(`${BASE_URL}${url}`, data);
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || "An error occurred while fetching data.";
    return {  status: false, error: errorMessage };
    // throw error; // This line is now unreachable and should be removed or handled differently.
  }
};


// New PATCH API function
export const patchRequest = async (url, data) => {
    try {
      const response = await axios.patch(`${BASE_URL}${url}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating:', error);
      const errorMessage = error.response?.data?.message || "An error occurred while updating data.";
      return { status: false, error: errorMessage };
    }
  };



  export const deleteRequest = async (url, params = {}, data = {}) => {
    try {
      const response = await axios.request({
        method: 'DELETE',
        url: `${BASE_URL}${url}`,
        params,  // Query parameters (id)
        data,    // Request body (email, name)
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting:', error);
      const errorMessage = error.response?.data?.message || "An error occurred while deleting data.";
      return { status: false, error: errorMessage };
    }
  };
  